import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestTypes } from '@core/react-query/features/profile/requestTypes'
import { profileKeys } from '@core/react-query/features/profile/profileKeys'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useUpdateProfileProperties = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['updateProfileProperties']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...profileKeys.updateProfileProperties,
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(profileKeys.profile.queryKey, {})
      options?.onSuccess?.(...args)
    },
  })
}
